import { makeAutoObservable, runInAction } from 'mobx';
import { clearToken, generateToken, getLocalToken, preValidateToken } from 'utils/auth';

class AuthStore {
    pendingAuth: Promise<string> | null = null;
    token: string | null = null;

    constructor() {
        makeAutoObservable(this);
        this.loadToken();
    }

    private loadToken() {
        this.token = getLocalToken();
    }

    private isTokenValid() {
        return preValidateToken();
    }

    setPendingAuth(pendingAuth: Promise<string>) {
        this.pendingAuth = pendingAuth;
    }

    async getToken(): Promise<string> {
        this.loadToken();
        if (this.token && this.isTokenValid()) {
            return this.token;
        }
        if (this.pendingAuth) {
            return this.pendingAuth;
        }
        try {
            this.setPendingAuth(generateToken());
            const newToken = await this.pendingAuth;
            runInAction(() => {
                this.token = newToken;
                this.pendingAuth = null;
            });
            return newToken!;
        } catch (error) {
            this.clearToken();
            throw error;
        }
    }

    clearToken() {
        runInAction(() => {
            this.token = null;
            this.pendingAuth = null;
        });
        clearToken();
    }
}

export const authStore = new AuthStore();
